import { type Ref, computed, reactive, toRefs } from 'vue'

const layoutConfig = reactive({
    darkTheme: false,
    activeMenuItem: ''
})

const layoutState = reactive({
    staticMenuDesktopInactive: false,
    profileSidebarVisible: false,
    configSidebarVisible: false,
    staticMenuMobileActive: false,
    activeMenuItem: ''
})

export const useLayout = () => {
    const changeThemeSettings = (theme: string) => {
        localStorage.setItem('theme', theme)
        layoutConfig.darkTheme = theme !== 'light'
        document.documentElement.classList.toggle('dark')
    }

    const setTheme = () => {
        const theme = localStorage.getItem('theme') ?? 'light'
        localStorage.setItem('theme', theme)
        if (theme === 'dark') {
            layoutConfig.darkTheme = true
            document.documentElement.classList.add('dark')
        } else layoutConfig.darkTheme = false
    }

    const setActiveMenuItem = (item: Ref<string> | string) => {
        if (typeof item === 'string') {
            layoutConfig.activeMenuItem = item
        } else {
            layoutConfig.activeMenuItem = item.value
        }
    }

    const onMenuToggle = () => {
        if (window.innerWidth > 1024) { // tailwind lg
            layoutState.staticMenuDesktopInactive = !layoutState.staticMenuDesktopInactive
        } else {
            layoutState.staticMenuMobileActive = !layoutState.staticMenuMobileActive
        }
    }

    const isSidebarActive = computed(() => layoutState.staticMenuMobileActive)

    return {
        layoutConfig: toRefs(layoutConfig),
        layoutState: toRefs(layoutState),
        changeThemeSettings,
        setTheme,
        onMenuToggle,
        isSidebarActive,
        setActiveMenuItem
    }
}

